export default __webpack_public_path__ + "static/media/pic5.24089643.jpg";